const normalizeCodeString = (value: string): string => {
  return value.trim();
};

export default normalizeCodeString;
